import React, { useState, useEffect } from 'react';
import { Wifi, Mountain, Flame } from 'lucide-react';
import { heroImages, apartmentInfo } from '../data/mock';

const Hero = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setIsTransitioning(true);
      setTimeout(() => {
        setCurrentImageIndex((prev) => (prev + 1) % heroImages.length);
        setIsTransitioning(false);
      }, 100);
    }, 6000);
    return () => clearInterval(interval);
  }, []);

  const scrollToReservation = (e) => {
    e.preventDefault();
    const element = document.querySelector('#rezervacija');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative h-screen min-h-[700px] overflow-hidden">
      {/* Background Images with Smooth Crossfade */}
      {heroImages.map((img, index) => (
        <div
          key={index}
          className="absolute inset-0"
          style={{
            opacity: index === currentImageIndex ? 1 : 0,
            transition: 'opacity 1.5s cubic-bezier(0.4, 0, 0.2, 1)',
            zIndex: index === currentImageIndex ? 1 : 0,
          }}
        >
          <div
            className="absolute inset-0 bg-cover bg-center"
            style={{ 
              backgroundImage: `url(${img})`,
              transform: index === currentImageIndex ? 'scale(1.05)' : 'scale(1)',
              transition: 'transform 8s ease-out',
            }}
          />
        </div>
      ))}

      {/* Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70 z-10" />

      {/* Content */}
      <div className="relative z-20 h-full flex flex-col items-center justify-center text-center px-4 sm:px-6 lg:px-8 pt-20">
        <p className="text-white text-sm md:text-base font-medium tracking-wider mb-4 animate-fade-in">
          Dobrodošli na Jahorinu
        </p>
        
        <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-serif font-bold text-white mb-4 leading-tight">
          <span className="block">{apartmentInfo.name}</span>
          <span className="block text-2xl sm:text-3xl md:text-4xl font-light text-white mt-2">
            {apartmentInfo.subtitle}
          </span>
        </h1>
        
        <p className="text-white/90 text-lg md:text-xl max-w-2xl mx-auto mb-8">
          {apartmentInfo.tagline}
        </p>

        <button
          onClick={scrollToReservation}
          className="bg-sage-600 hover:bg-sage-700 text-white px-8 py-4 rounded-lg text-lg font-medium transition-all duration-300 shadow-2xl hover:shadow-sage-600/30 hover:scale-105 mb-12"
        >
          Pošalji upit
        </button>

        {/* Features */}
        <div className="flex flex-wrap justify-center gap-4 md:gap-8">
          {[
            { icon: Mountain, label: 'Pogled na planine' },
            { icon: Wifi, label: 'Besplatan WiFi' },
            { icon: Flame, label: 'Kamin' },
          ].map((feature, index) => (
            <div
              key={index}
              className="flex items-center gap-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full text-white text-sm"
            >
              <feature.icon size={18} className="text-sage-400" />
              <span>{feature.label}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Image Indicators */}
      <div className="absolute bottom-24 left-1/2 transform -translate-x-1/2 z-20 flex gap-2">
        {heroImages.map((_, index) => (
          <div
            key={index}
            className={`w-2 h-2 rounded-full transition-all duration-500 ${
              index === currentImageIndex 
                ? 'bg-sage-400 w-8' 
                : 'bg-white/50 hover:bg-white/70'
            }`}
          />
        ))}
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-20 animate-bounce">
        <div className="w-6 h-10 border-2 border-white/50 rounded-full flex justify-center pt-2">
          <div className="w-1.5 h-3 bg-white/70 rounded-full" />
        </div>
      </div>
    </section>
  );
};

export default Hero;